var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container"},[_c('div',{staticClass:"box__content-container"},_vm._l((_vm.count),function(box,i){return _c('div',{key:`box-${i}`,staticClass:"box",class:[`background-${_vm.bgColor}`, `box-${_vm.bgColor}`]})}),0),_c('div',{staticClass:"box__title",class:{ 'box__title--show': _vm.showTitle }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }